import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { TEAM } from '../data/mock';

const ASSURANCE = [
  'Sunday Mirror Certified professionals',
  'Clear scopes',
  'Transparent communication',
  'Documented approvals',
  'Planning timelines',
  'Service-quality standards',
  'Post-wedding performance review',
  'Contingency planning',
  'Named accountability',
];

export default function About() {
  return (
    <main className="pt-32">
      <section className="max-w-[1100px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>About Sunday Mirror</SectionLabel>
        <Heading className="mt-5 font-serif">We believe the best wedding memories<br/><span className="italic">shouldn’t include the stress of producing them.</span></Heading>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-10 pb-20 grid lg:grid-cols-2 gap-12 items-start">
        <div className="space-y-6 text-[#304247] text-lg leading-[1.9]">
          <p>Sunday Mirror was created around one simple idea: a couple should be able to dream about getting married anywhere in the world without wondering who will manage everything.</p>
          <p>So we bring planning, destination expertise, Sunday Mirror Certified professionals, hospitality and event execution together under one team.</p>
          <p className="font-serif italic text-2xl text-[#053e49]">We obsess over the details so our couples don’t have to.</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <img src="https://images.unsplash.com/photo-1633104502699-b2ecf0fee294" alt="" className="aspect-[3/4] object-cover" />
          <img src="https://images.unsplash.com/photo-1587271315307-eaebc181c749" alt="" className="aspect-[3/4] object-cover mt-10" />
        </div>
      </section>

      <section className="bg-[#fbf8f2] py-24">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10">
          <SectionLabel>The Team</SectionLabel>
          <Heading className="mt-5 font-serif">Meet the people <span className="italic">behind your wedding.</span></Heading>
          <p className="mt-6 max-w-2xl text-[#4a5c60]">Beautiful weddings don’t happen because of one planner. They happen because specialists work together.</p>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {TEAM.map((t) => (
              <div key={t.name} className="group">
                <div className="aspect-[4/5] overflow-hidden"><img src={t.photo} alt={t.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" /></div>
                <h3 className="font-serif text-xl text-[#053e49] mt-4">{t.name}</h3>
                <div className="text-xs text-[#6b7c80] mt-1">{t.role}</div>
                <div className="text-xs text-[#a6894f] mt-1">{t.destinations}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#053e49] text-[#faf4ea] py-24">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <SectionLabel dark>The Sunday Mirror Assurance</SectionLabel>
          <Heading dark className="mt-5 font-serif">Destination weddings <span className="italic text-[#ffeabf]">involve trust.</span></Heading>
          <p className="mt-6 text-[#d8d0bf]">We take that seriously. Our operating principles include:</p>
          <div className="mt-10 grid md:grid-cols-3 gap-4">
            {ASSURANCE.map((a, i) => (
              <div key={a} className="border border-[#0b5260] p-5 hover:border-[#c3a66d] transition-colors">
                <div className="font-serif text-[#c3a66d] text-sm">{String(i+1).padStart(2,'0')}</div>
                <div className="font-serif text-lg text-[#ffeabf] mt-2">{a}</div>
              </div>
            ))}
          </div>
          <p className="mt-10 font-serif italic text-xl text-[#ffeabf]">Your wedding is personal. Our responsibility is professional.</p>
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
